export default "__VITE_ASSET__8018fc00__"